import React from 'react'
import 'font-awesome/css/font-awesome.css'

import '../scss/overflow/assets/sass/main.scss'

export default function Layout({ children }) {
  return <div className="app-wrapper">{children}</div>
}
